export const LOADING_TRAVELERS = "Fetching travelers";
export const LOADING_GENERIC = "Loading";
export const CART_UPDATE_TEXT = "Fetching latest price";

export const ADDITIONAL_DETAILS_HEADING = "Additional details";
